import { useConfigQuery } from 'api/feeds';
import React, { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { topicalRoutes } from './router';
import Loader from 'components/ui/Loader';

const App = () => {
  const { isSuccess } = useConfigQuery();

  return (
    <div>
      <Suspense fallback={<Loader />}>
        {isSuccess && <RouterProvider router={topicalRoutes} />}
      </Suspense>
    </div>
  );
};
export { App };
